module.exports = __webpack_public_path__ + "static/media/29ADMSPC36.5e5d6862.jpg";